/**
 * Error thrown by the API client on non-OK responses. Kept in its own
 * dependency-free leaf module so that both `services/api.ts` and the
 * self-contained `api/twoFactor.ts` client can import it without forming an
 * import cycle.
 */
export class ApiError extends Error {
  constructor(
    public statusCode: number,
    public code: string,
    message: string,
    public details?: Record<string, unknown>
  ) {
    super(message);
    this.name = 'ApiError';
  }
}
